import Cookies from 'universal-cookie';

export function getCookie(name) {
    const cookies = new Cookies();
    return cookies.get(encodeURIComponent(name));
}

export function setCookie(name, value) {
    const cookies = new Cookies();
    const ninetyDays = new Date();
    ninetyDays.setDate(new Date().getDate() + 90);
    cookies.set(encodeURIComponent(name), encodeURIComponent(value), { expires: ninetyDays, path: '/' });
}

export function setUserCookie(userId, cookieName, val) {
    let objToggleView;
    try {
        objToggleView = getCookie(cookieName) ? JSON.parse(decodeURIComponent(getCookie(cookieName))) : {};
    } catch {
        objToggleView = {};
    }
    objToggleView[userId] = val;
    setCookie(cookieName, JSON.stringify(objToggleView))
}